<script setup lang="ts">

</script>

<template>
  <div class="w-full">
    <div class="mx-auto flex flex-col items-center gap-y-6">
      <img
        class="size-[88px] object-cover"
        src="@/assets/images/emojis/emoji-rocket.png"
      >
      <div class="flex flex-col gap-y-2 text-base font-medium text-white/60">
        <div class="text-center text-light-white text-[18px] leading-7 font-bold">
          Phase 1: Snapshot
        </div>
        <p>
          <span class="text-white/[.87] font-semibold">On May 31 at 09:00 UTC</span>, we’ll <span>capture your Dropee stats</span>
          across three pillars to lock
          in your
          baseline
          score:
        </p>
        <ul class="list-disc pl-5">
          <li>
            <span class="text-white/[.87] font-semibold">Dropee Journey:</span> Time in-game, ranks, loyalty &
            contributions
          </li>
          <li>
            <span class="text-white/[.87] font-semibold">Gameplay & Activity:</span> All the core in-app actions:
            progress, cards, and interactions
          </li>
          <li>
            <span class="text-white/[.87] font-semibold">Advanced & Events:</span> Advanced gameplay and special
            events
          </li>
        </ul>
        <p>
          These represent everything we reward: your <span class="text-white/[.87] font-semibold">dedication, progression & engagement.</span>
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>